import {Component} from '@angular/core';
import { Notification,User } from  '@app/_models';
import { AppService } from '@app/_services';
import { AuthenticationService } from '@app/_services';
@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.css']
})
export class NotificationsComponent {
  public notifications: Notification[];
  public noOfRecords: Number;
  public pageSize: number = 5;
  public notification: Notification;
  public pageIndex: number = 0;
  currentUser: User;
  userLoggedIn: boolean;
  constructor(
      private authenticationService: AuthenticationService,
      private api: AppService) {
          this.authenticationService.currentUser.subscribe(x =>{
              this.currentUser = x
              if(this.currentUser){
                  this.userLoggedIn = true;
                  this.getNotifications(1);
          
              }
          });
  }
  refreshList(){
      this.getNotifications(1); 
  }
  getNotifications(_pageNo:number) {
  
      this.api.getNotifications(this.currentUser.id,this.pageSize,_pageNo)
          .subscribe(result => {
              this.notifications = result.results;
              this.noOfRecords = result.noOfRecords;
          });
  }
  displayActivePage(activePageNumber:number){  
    this.getNotifications(activePageNumber); 
  } 
}
